"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.START = exports.SAGA = void 0;
var SAGA = 'app/updateFlow/SAGA';
exports.SAGA = SAGA;
var START = 'app/updateFlow/START';
exports.START = START;
var SUCCESS = 'app/updateFlow/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'app/updateFlow/FAILURE';
exports.FAILURE = FAILURE;